export const langCode = {
  pl: 'pl-PL',
  en: 'en-US',
};